import { useMemo } from 'react';
import { useQuery } from '@apollo/client/react';
import get from 'lodash/get';
import { COUNT_TABLE_RECORDS } from 'constants/constants';
import {
  CO2SavingsByProjectsDocument,
  type CO2SavingsByProjectsQuery,
} from 'graphql/generated/graphql';

export type TCO2Calculation =
  CO2SavingsByProjectsQuery['co2SavingsByProjects']['co2Calculations'][number];

const useCO2SavingsByProjects = ({
  currentPage = 1,
  filter = '',
}: {
  currentPage?: number;
  filter?: string;
}) => {
  const offset = COUNT_TABLE_RECORDS * (currentPage - 1);

  // errorPolicy 'all': a calculation whose project is gone (archived) fails with project.not_found; the page shows
  // the calculations that came and the error instead of nothing.
  const { data, loading, error } = useQuery(CO2SavingsByProjectsDocument, {
    variables: { filter, offset, limit: COUNT_TABLE_RECORDS },
    errorPolicy: 'all',
  });

  const co2Calculations = useMemo(
    () => get(data, 'co2SavingsByProjects.co2Calculations', null),
    [data],
  );
  const count = useMemo(() => get(data, 'co2SavingsByProjects.count', null), [data]);

  return { co2Calculations, count, loading, error };
};

export default useCO2SavingsByProjects;
